import React, { useState } from 'react';
import Modal from './Modal';
import ContactForm from './ContactForm';
import './BecomeA.css';

function BecomeA() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formType, setFormType] = useState('');

  const handleJoinClick = (type) => {
    setFormType(type);
    setIsModalOpen(true);
  };

  function CallToActionCard({ title, description, buttonText, color }) {
    const handleClick = () => {
      if (buttonText !== 'Donate Now') {
        handleJoinClick(title);
      }
    };

    return (
      <div className="cta-card" style={{ backgroundColor: color }}>
        <h2>{title}</h2>
        <p>{description}</p>
        <div className="divider"></div>
        <button className="cta-button" onClick={handleClick}>
          {buttonText}
        </button>
      </div>
    );
  }

  return (
    <div className="app">
      <div className="cards-container">
        <CallToActionCard
          title="Become a Mentor"
          description="Got wisdom and passion for guiding others? We've got meaningful mentorship opportunities."
          buttonText="Join Us Now"
          color="#FFD1DC" // Pastel pink
        />
        
        <CallToActionCard
          title="Become a Volunteer"
          description="Got skills and passion for justice? We've got meaningful work changing lives in Uganda!"
          buttonText="Join Us Now"
          color="#B5EAD7" // Mint green
        />
        
        <CallToActionCard
          title="Become a Donor"
          description="Got resources and passion for making a difference? We've got impactful projects."
          buttonText="Donate Now"
          color="#E2F0CB" // Soft green
        />
      </div>
      
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <ContactForm 
          onClose={() => setIsModalOpen(false)} 
          formType={formType}
        />
      </Modal>
    </div>
  );
}

export default BecomeA;